module.exports = __webpack_public_path__ + "media/bangkok/bangkok bugs-b2c564d0.jpg";